import { useCallback, useRef } from 'react';

type UseMultiTapOptions = {
  /** 必要なタップ回数。デフォルト: 3 */
  tapCount?: number;
  /** タップ間の最大間隔（ミリ秒）。デフォルト: 500 */
  maxInterval?: number;
  /** 指定回数タップ完了時のコールバック */
  onMultiTap: () => void;
};

type UseMultiTapResult = {
  onClick: (e: React.MouseEvent | React.TouchEvent) => void;
};

/**
 * 複数回タップ検出用のカスタムフック
 * PC（クリック）とタッチデバイス両方に対応
 */
export const useMultiTap = ({
  tapCount = 3,
  maxInterval = 500,
  onMultiTap,
}: UseMultiTapOptions): UseMultiTapResult => {
  const tapCountRef = useRef(0);
  const lastTapTimeRef = useRef(0);

  const onClick = useCallback(
    (_e: React.MouseEvent | React.TouchEvent) => {
      const now = Date.now();
      const timeSinceLastTap = now - lastTapTimeRef.current;

      if (timeSinceLastTap < maxInterval) {
        tapCountRef.current += 1;
      } else {
        tapCountRef.current = 1;
      }

      lastTapTimeRef.current = now;

      if (tapCountRef.current >= tapCount) {
        tapCountRef.current = 0;
        onMultiTap();
      }
    },
    [tapCount, maxInterval, onMultiTap]
  );

  return {
    onClick,
  };
};
